import { useState } from "react";
import { motion } from "framer-motion";
import { Image as ImageIcon } from "lucide-react";
import SceneShell from "../components/SceneShell";

/**
 * Scene 10 — Website screenshot.
 *
 * Drop a static image at `/app/frontend/public/website-screenshot.png` and it
 * will appear here automatically. Until then a clean labelled placeholder is shown.
 */
const SCREENSHOT_SRC = "/website-screenshot.png";

export default function Scene10_WebsiteShowcase() {
  const [imageOk, setImageOk] = useState(true);
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-website-showcase">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(150,193,31,0.10) 0%, transparent 60%)",
        }}
      />

      <div className="relative max-w-[1700px] mx-auto w-full text-center">
        <motion.figure
          initial={{ opacity: 0, y: 24, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1.1, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="relative mx-auto rounded-2xl overflow-hidden"
          style={{
            maxWidth: "1400px",
            aspectRatio: "16/9",
            background: "rgba(255,255,255,0.03)",
            border: "1px solid rgba(255,255,255,0.10)",
            boxShadow: "0 30px 80px -20px rgba(0,0,0,0.65)",
          }}
          data-testid="website-screenshot"
        >
          {imageOk ? (
            <img
              src={SCREENSHOT_SRC}
              alt="NicheCom website screenshot"
              className="absolute inset-0 w-full h-full object-cover"
              onError={() => setImageOk(false)}
            />
          ) : (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 pointer-events-none">
              <ImageIcon
                className="w-10 h-10"
                style={{ color: "rgba(150,193,31,0.65)" }}
              />
              <div
                className="text-[11px] tracking-[0.32em] uppercase"
                style={{ color: "rgba(255,255,255,0.55)" }}
              >
                Drop screenshot at /public/website-screenshot.png
              </div>
            </div>
          )}
        </motion.figure>
      </div>
    </SceneShell>
  );
}
